import React from 'react';
import { Link } from 'react-router-dom';
import { EMAIL, PHONE, ADDRESS, waLink, img } from '../data/content';
import { productSeo } from '../data/seo';

const machineLinks = ['rotary-table', 'cabinet', 'spm-compact', 'through-feed', 'ultrasonic', 'robotic', 'tailor-made'];

export default function Footer() {
  return (
    <footer className="relative border-t border-steelline/60 bg-surface/40 overflow-hidden" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 pt-16 pb-8">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img src={img('logo.jpg')} alt="Tekwash Systems Pvt Ltd" className="h-14 w-auto mix-blend-screen" />
            <p className="mt-5 text-sm leading-relaxed text-fog max-w-sm">
              Leading state-of-the-art designers & manufacturers of industrial component cleaning systems.
              12+ years of engineering excellence from Pune, installed across India.
            </p>
            <a
              href={waLink('Hello Tekwash Systems, I have a component cleaning requirement.')}
              target="_blank" rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="mt-6 inline-flex items-center gap-2 border border-steelline px-4 py-2.5 font-mono text-xs uppercase tracking-[0.2em] text-paper hover:border-flame hover:text-flame transition-colors"
            >
              WhatsApp Our Engineers
            </a>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-flame mb-5">Machines</h3>
            <ul className="space-y-3">
              {machineLinks.map((id) => (
                <li key={id}>
                  <Link to={`/products/${productSeo[id].slug}`} data-testid={`footer-product-${id}`} className="text-sm text-fog hover:text-paper transition-colors">
                    {productSeo[id].h1}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-mono text-xs uppercase tracking-[0.25em] text-flame mb-5">Contact</h3>
            <ul className="space-y-4 text-sm text-fog">
              <li>
                <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="hover:text-paper transition-colors">{EMAIL}</a>
              </li>
              <li>
                <a href={`tel:${PHONE.replace(/\s/g, '')}`} data-testid="footer-phone-link" className="hover:text-paper transition-colors">{PHONE}</a>
              </li>
              <li className="leading-relaxed">Regd Office: {ADDRESS}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 select-none overflow-hidden" aria-hidden="true">
          <p className="font-display font-extrabold text-outline text-[18vw] md:text-[11vw] leading-none tracking-tight">TEKWASH</p>
        </div>

        <div className="mt-6 pt-6 border-t border-steelline/50 flex flex-col sm:flex-row justify-between gap-3 text-xs text-fog/70">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} Tekwash Systems Pvt Ltd. All rights reserved.</p>
          <p className="font-mono uppercase tracking-[0.2em]">Pune · Maharashtra · India</p>
        </div>
      </div>
    </footer>
  );
}
